import { EPTemplate } from './ep-template';
import { NgModule } from '@angular/core';
import { FormlyModule } from '@ngx-formly/core';

@NgModule({
  imports: [
    FormlyModule
  ],
  declarations: [
    EPTemplate
  ],
  exports: [
    EPTemplate
  ]
})

export class EPTemplateModule {
}
